
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNetwork = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 30,
  height: 30,
  textRendering: "geometricPrecision",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "network_ff18793058ae1530__a",
  width: 30,
  height: 30,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAgVBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+q+H6aAAAAK3RSTlMAsLGgtXoMiSPemGLmLHvw66wk5ePceCUcfB6Hot2jyIqLV1yzWL27XSJe9fs2EQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAOVJREFUeNqd0+kOgjAMAOAC475RPEHkVt//AV1ZSUC2kLgfJeNLlq5rAZbLCAIDVMtyvTD0SkvBpo5RNxWs+Rh9TcGPCGNUKPiTZABZ0sv1fOjiNI1H9ybXEziMOXCXOSqAbfMgcaGCt05KvHTL1B4v0pm594VmYv1c3Y+SDtYMYxL5eslfweObLH6v2Yl5CcAzIAhxmzJ7WlUlvizFv2Gwx3S4ozhcpMZ+Uxsoteli7fG65jpv6GLiMHLiZ35Zl41c8EZnn1iiwqcHrWWKzrAdBrkCtKKZmv9acaeRd8ZgZ4gkI/gFiZYPnSaK0ZUAAAAASUVORK5CYII=",
  width: 30,
  height: 30,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAgVBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+q+H6aAAAAK3RSTlMAsLGgtXoMiSPemGLmLHvw66wk5ePceCUcfB6Hot2jyIqLV1yzWL27XSJe9fs2EQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAOVJREFUeNqd0+kOgjAMAOAC475RPEHkVt//AV1ZSUC2kLgfJeNLlq5rAZbLCAIDVMtyvTD0SkvBpo5RNxWs+Rh9TcGPCGNUKPiTZABZ0sv1fOjiNI1H9ybXEziMOXCXOSqAbfMgcaGCt05KvHTL1B4v0pm594VmYv1c3Y+SDtYMYxL5eslfweObLH6v2Yl5CcAzIAhxmzJ7WlUlvizFv2Gwx3S4ozhcpMZ+Uxsoteli7fG65jpv6GLiMHLiZ35Zl41c8EZnn1iiwqcHrWWKzrAdBrkCtKKZmv9acaeRd8ZgZ4gkI/gFiZYPnSaK0ZUAAAAASUVORK5CYII=",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
})), /*#__PURE__*/React.createElement("mask", {
  id: "network_ff18793058ae1530__b",
  width: 30,
  height: 30,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABlBMVEVMaXH///+a4ocPAAAAAnRSTlMAFRtOKdMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAAeSURBVHjaY2BAAoxwYhTQEjCSLTmSnTZykgZKOAMAEioACZLkDDkAAAAASUVORK5CYII=",
  width: 30,
  height: 30,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABlBMVEVMaXH///+a4ocPAAAAAnRSTlMAFRtOKdMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAAeSURBVHjaY2BAAoxwYhTQEjCSLTmSnTZykgZKOAMAEioACZLkDDkAAAAASUVORK5CYII=",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  shapeRendering: "crispEdges"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#network_ff18793058ae1530__a)",
  d: "M0 0h30v30H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary-grad,#6e216f)",
  mask: "url(#network_ff18793058ae1530__b)",
  d: "M0 0h30v30H0z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"30\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 30 30\"><defs><mask id=\"layer-0\" width=\"30\" height=\"30\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAgVBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+q+H6aAAAAK3RSTlMAsLGgtXoMiSPemGLmLHvw66wk5ePceCUcfB6Hot2jyIqLV1yzWL27XSJe9fs2EQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAOVJREFUeNqd0+kOgjAMAOAC475RPEHkVt//AV1ZSUC2kLgfJeNLlq5rAZbLCAIDVMtyvTD0SkvBpo5RNxWs+Rh9TcGPCGNUKPiTZABZ0sv1fOjiNI1H9ybXEziMOXCXOSqAbfMgcaGCt05KvHTL1B4v0pm594VmYv1c3Y+SDtYMYxL5eslfweObLH6v2Yl5CcAzIAhxmzJ7WlUlvizFv2Gwx3S4ozhcpMZ+Uxsoteli7fG65jpv6GLiMHLiZ35Zl41c8EZnn1iiwqcHrWWKzrAdBrkCtKKZmv9acaeRd8ZgZ4gkI/gFiZYPnSaK0ZUAAAAASUVORK5CYII=\" width=\"30\" height=\"30\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAgVBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+q+H6aAAAAK3RSTlMAsLGgtXoMiSPemGLmLHvw66wk5ePceCUcfB6Hot2jyIqLV1yzWL27XSJe9fs2EQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAOVJREFUeNqd0+kOgjAMAOAC475RPEHkVt//AV1ZSUC2kLgfJeNLlq5rAZbLCAIDVMtyvTD0SkvBpo5RNxWs+Rh9TcGPCGNUKPiTZABZ0sv1fOjiNI1H9ybXEziMOXCXOSqAbfMgcaGCt05KvHTL1B4v0pm594VmYv1c3Y+SDtYMYxL5eslfweObLH6v2Yl5CcAzIAhxmzJ7WlUlvizFv2Gwx3S4ozhcpMZ+Uxsoteli7fG65jpv6GLiMHLiZ35Zl41c8EZnn1iiwqcHrWWKzrAdBrkCtKKZmv9acaeRd8ZgZ4gkI/gFiZYPnSaK0ZUAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask><mask id=\"layer-1\" width=\"30\" height=\"30\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABlBMVEVMaXH///+a4ocPAAAAAnRSTlMAFRtOKdMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAAeSURBVHjaY2BAAoxwYhTQEjCSLTmSnTZykgZKOAMAEioACZLkDDkAAAAASUVORK5CYII=\" width=\"30\" height=\"30\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABlBMVEVMaXH///+a4ocPAAAAAnRSTlMAFRtOKdMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAAeSURBVHjaY2BAAoxwYhTQEjCSLTmSnTZykgZKOAMAEioACZLkDDkAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAhFBMVEVMaXGWDP+NAPSPAPWNAPSLAPOLAPOLAPSUAP2JAPKKAPONAPSNAP+LAPKMAPSLAPOJAPKSAPuMAPSSAP6JAPKLAPOJAPKJAPKMAPeRAPqLAPOVAPyOAPaNAPSMAPSLAPKNAPSKAPSLAPSLAPWLAPONAPSNAPWMAPSNAPSZAP6MAPSKAPT/GjAkAAAALHRSTlMADLFitXqwiSPee6AV5pjr8CysJOXj3HglHHweh6Kj3ciKi1dcs1i9uyJeXZuq9gwAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADpSURBVHjandPpDoMgDADgqngfeGzudDrvbe//fgOpiU6IyfhRg19CSmkBFivww9APQLE0N0qSqNQUbOo86qaCLYNHw1Lww+PRKxT8phlARnu5ng9dnKbx6N7kegKHEAfuMucKYNssSFyo4K2jIi9dM63HB3Vm5n1hmax+gasbHu1gzTBSz9DLAPyIbbL4tWYnZiWAyIcw4duU2NOqKvElKf+bhHuMhzuKw0Vq5De1AVObLtYer2uu80ZcDA9DR37ml3XZ0AVvdPaJJSp8etBaptwJb4dBrgCtaKbmv1bcaeSdMdgZIskIfgE2pxCJM87o1gAAAABJRU5ErkJggg==\" id=\"convert2-source\" width=\"30\" height=\"30\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAhFBMVEVMaXGWDP+NAPSPAPWNAPSLAPOLAPOLAPSUAP2JAPKKAPONAPSNAP+LAPKMAPSLAPOJAPKSAPuMAPSSAP6JAPKLAPOJAPKJAPKMAPeRAPqLAPOVAPyOAPaNAPSMAPSLAPKNAPSKAPSLAPSLAPWLAPONAPSNAPWMAPSNAPSZAP6MAPSKAPT/GjAkAAAALHRSTlMADLFitXqwiSPee6AV5pjr8CysJOXj3HglHHweh6Kj3ciKi1dcs1i9uyJeXZuq9gwAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADpSURBVHjandPpDoMgDADgqngfeGzudDrvbe//fgOpiU6IyfhRg19CSmkBFivww9APQLE0N0qSqNQUbOo86qaCLYNHw1Lww+PRKxT8phlARnu5ng9dnKbx6N7kegKHEAfuMucKYNssSFyo4K2jIi9dM63HB3Vm5n1hmax+gasbHu1gzTBSz9DLAPyIbbL4tWYnZiWAyIcw4duU2NOqKvElKf+bhHuMhzuKw0Vq5De1AVObLtYer2uu80ZcDA9DR37ml3XZ0AVvdPaJJSp8etBaptwJb4dBrgCtaKbmv1bcaeSdMdgZIskIfgE2pxCJM87o1gAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/></defs><g shape-rendering=\"crispEdges\"><rect width=\"30\" height=\"30\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\"/><rect width=\"30\" height=\"30\" fill=\"var(--theme-primary-grad,#6e216f)\" mask=\"url(#layer-1)\"/></g></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/network.ff18793058ae15308ec263b2a6ac9807.svg"),
        {
          React: SvgNetwork,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      